import { createSlice } from '@reduxjs/toolkit';
import { PARTNER_ASSISTANT_ROLE, PARTNER_ROLE, RADIOLOGIST_MANAGER_ROLE } from '../utils/constants';

export const globalSlice = createSlice({
	name: 'global',
	initialState: {
		role: 'doctor',
		locale: 'en',
		branch: {
			id: 1,
			value: 'london',
			name: 'London',
			address: 'Mock London Address',
			dayStart: '08:00:00',
			dayEnd: '20:00:00',
			slotDuration: '00:05:00',
			hiddenDays: [0],
		},
		loggedInUser: null,
		isUserPartnerOrAssistant: false,
		isUserPartnerOrAssistantOrManager: false,
		isPartner: false,
		isAssistant: false,
		activeAccount: null,
	},
	reducers: {
		setRole: (state, action) => {
			state.role = action.payload.role;
		},
		setBranch: (state, action) => {
			state.branch = action.payload.branch;
		},
		setLocale: (state, action) => {
			state.locale = action.payload.locale;
		},
		setLoggedInUser: (state, action) => {
			state.loggedInUser = action.payload;
			const isPartner = action.payload.roles?.includes(PARTNER_ROLE);
			const isAssistant =
				action.payload.roles?.includes(PARTNER_ASSISTANT_ROLE);
			state.isUserPartnerOrAssistant = isPartner || isAssistant;
			const isRadiologistManager = action.payload.roles?.includes(RADIOLOGIST_MANAGER_ROLE);
			state.isUserPartnerOrAssistantOrManager = state.isUserPartnerOrAssistant || isRadiologistManager;
			state.isPartner = isPartner;
			state.isAssistant = isAssistant;
		},
		setActiveAccount: (state, action) => {
			state.activeAccount = action.payload;
		},
	},
});

export const {
	setRole,
	setBranch,
	setLocale,
	setLoggedInUser,
	setActiveAccount,
} = globalSlice.actions;

export const selectRole = (state) => state.global.role;
export const selectBranch = (state) => state.global.branch;
export const selectLocale = (state) => state.global.locale;
export const selectLoggedInUser = (state) => state.global.loggedInUser;
export const selectIsUserPartnerOrAssistant = (state) =>
	state.global.isUserPartnerOrAssistant;
export const selectIsUserPartnerOrAssistantOrManager = (state) =>
	state.global.isUserPartnerOrAssistantOrManager;
export const selectIsPartner = (state) => state.global.isPartner;
export const selectIsAssistant = (state) => state.global.isAssistant;
export const selectActiveAccount = (state) => state.global.activeAccount;

export default globalSlice.reducer;
